<template>
  <b-container fluid>
    <!-- Header -->
    <b-row md="12" class="mb-3">
      <b-col class="mb-2 mb-sm-0" md="4">
        <strong>Sub Agent ID</strong>
        <div><b-badge variant="primary">{{ propWrkSubAgentObj.sa_id || "N/A" }}</b-badge></div>
      </b-col>
      <b-col class="mb-2 mb-sm-0" md="4">
        <strong>Order</strong>
        <div><b-badge variant="primary">{{ propWrkSubAgentObj.sa_order_id || "N/A" }}</b-badge></div>
      </b-col>
      <b-col class="mb-2 mb-sm-0" md="4">
        <strong>Agent ID</strong>
        <div><b-badge variant="primary">{{ propWrkSubAgentObj.agent_id || "N/A" }}</b-badge></div>
      </b-col>
    </b-row>

    <!-- Type/Service/Action -->
    <b-row class="mb-3">
      <b-col class="mb-2 mb-sm-0" md="4">
        <strong>Type</strong>
        <div><b-badge variant="primary">{{ propWrkSubAgentObj.sa_type || "N/A" }}</b-badge></div>
      </b-col>
      <b-col class="mb-2 mb-sm-0" md="4">
        <strong>Service</strong>
        <div><b-badge variant="secondary">{{ propWrkSubAgentObj.sa_svc || "-" }}</b-badge></div>
      </b-col>
      <b-col class="mb-2 mb-sm-0" md="4">
        <strong>Action</strong>
        <div>{{ propWrkSubAgentObj.sa_action || "-" }}</div>
        <!-- <b-badge variant="secondary">{{ propWrkSubAgentObj.sa_action || "-" }}</b-badge> -->
      </b-col>
    </b-row>

    <!-- Description -->
    <b-row class="mb-3">
      <b-col>
        <iq-card class="p-3">
          <template v-slot:body>
            <h6 class="mb-2">Description</h6>
            <div v-if="propWrkSubAgentObj.sa_desc" class="content-view-container">
              <pre class="content-display">{{ propWrkSubAgentObj.sa_desc }}</pre>
            </div>
            <div v-else class="text-muted">No Description Found</div>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <!-- Payload/Output -->
    <b-row class="mb-3">
      <b-col md="6">
        <iq-card class="p-3">
          <template v-slot:body>
            <h6 class="mb-2">Payload</h6>
            <div v-if="propWrkSubAgentObj.sa_payload" class="content-view-container">
              <pre class="content-display">{{ safePre(propWrkSubAgentObj.sa_payload) }}</pre>
            </div>
            <div v-else class="text-muted">No Payload</div>
          </template>
        </iq-card>
      </b-col>
      <b-col md="6">
        <iq-card class="p-3">
          <template v-slot:body>
            <h6 class="mb-2">Output</h6>
            <div v-if="propWrkSubAgentObj.sa_output" class="content-view-container">
              <pre class="content-display">{{ safePre(propWrkSubAgentObj.sa_output) }}</pre>
            </div>
            <div v-else class="text-muted">No Output</div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit.js"

export default {
  name: "wrkSubAgentView",
  props: {
    propWrkSubAgentObj: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    /**
     * safePre
     */
    safePre (v) {
      if (v === null || v === undefined) return ""
      const s = typeof v === "string" ? v : JSON.stringify(v, null, 2)
      return s
    }
  },
  mounted () {
    socialvue.index()
  }
}
</script>

<style scoped>
.content-view-container {
  max-height: 420px;
  overflow-y: auto;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}
.content-display {
  margin: 0;
  padding: 16px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 13px;
  line-height: 1.6;
  font-family: Consolas, Monaco, monospace;
}
</style>
